module.exports = __webpack_public_path__ + "media/images/anatarashiku@2x-2d28afbfae205e09024a4eb27886e2eb.jpg";